import SEOHead from '@/components/base/SEOHead';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import FeaturedArticles from './components/FeaturedArticles';
import FAQSection from './components/FAQSection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '芒果视频',
  url: 'https://www.mangoshipin.cn/',
  description: '芒果视频作为蜜桃视频、糖豆视频之外的优质推荐，资源丰富播放流畅。对比蘑菇视频、蓝莓视频，芒果视频App好用且免费高清，值得选择。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.mangoshipin.cn/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const orgSchema = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '芒果视频',
  url: 'https://www.mangoshipin.cn/',
  description: '资源丰富，播放流畅，免费高清的视频平台',
  contactPoint: {
    '@type': 'ContactPoint',
    email: 'contact@mangoshipin.cn',
    contactType: 'customer service',
  },
};

export default function Home() {
  return (
    <>
      <SEOHead schema={{ ...homeSchema, ...orgSchema }} />
      <ScrollToTop />
      <Navbar />
      <main>
        <HeroSection />
        <CategorySection />
        <FeaturedArticles />
        <FAQSection />
      </main>
      <Footer />
    </>
  );
}